// extracted by mini-css-extract-plugin
export default {"wrapper":"Login_wrapper__7Qn5Z","form":"Login_form__HoQ6M","title":"Login_title__SJ0Uv","input":"Login_input__6Emyd","submit":"Login_submit__4Nmpx"};